<template>
  <div class="tco-choose-product-container">
    <TcoChooseMultipleProductRules
      v-if="promoProductsTcoToChoose"
      :promoProductsTco="promoProductsTco"
      :promoProductsTcoToChoose="promoProductsTcoToChoose"
    />
    <TcoChooseProductRules v-else />

    <TcoProductListGrid
      class="mt-5"
      @promoProductsTcoToChoose="setPromoProductsTcoToChoose"
      @promoProductsTco="setPromoProductsTco"
    />
  </div>
</template>
<script>
import TcoChooseProductRules from "@/components/cardOro/TcoChooseProductRules.vue";
import TcoChooseMultipleProductRules from "@/components/cardOro/TcoChooseMultipleProductRules.vue";

import TcoProductListGrid from "@/components/cardOro/TcoProductListGrid.vue";

export default {
  name: "TcoChooseProduct",
  components: {
    TcoChooseProductRules,
    TcoChooseMultipleProductRules,
    TcoProductListGrid
  },
  data() {
    return {
      modalOpen: false,
      promoProductsTcoToChoose: null,
      promoProductsTco: []
    };
  },
  computed: {},
  methods: {
    setPromoProductsTco(promoProductsTco) {
      this.promoProductsTco = promoProductsTco;
    },
    setPromoProductsTcoToChoose(promoProductsTcoToChoose) {
      this.promoProductsTcoToChoose = promoProductsTcoToChoose;
    }
  }
};
</script>
